export const THEME_COLORS = {
  ex: {
    primary: '#ffc83a',
    secondary: '#ffedbd',
    footer: '#fff3d3',
    hoverItem: '#fff9e9',
    primaryDarker: '#F3AF00',
    primaryDarker2: '#dd9900',
    secondaryDarker: '#b4b4b4',
  },
  mi: {
    primary: '#8A8AF6',
    secondary: '#d7d7fc',
    hoverItem: '#f0f0fc',
    footer: '#e8e8fc',
    primaryDarker: '#7c7cf7',
    primaryDarker2: '#7c7cf7',
    secondaryDarker: '#b4b4b4',
  },
  vt: {
    primary: '#3294fc',
    secondary: '#CCE5FF',
    footer: '#E3F2FD',
    hoverItem: '#B8DAFF',
    primaryDarker: '#0056b3',
    primaryDarker2: '#0056b3',
    secondaryDarker: '#99CCFF',
  },
  ap: {
    primary: '#34C759',
    secondary: '#D9F7E5',
    footer: '#E6F9EF',
    hoverItem: '#C8F2DB',
    primaryDarker: '#28A745',
    primaryDarker2: '#1E8E3E',
    secondaryDarker: '#AEEFC8',
  },
};
